import type { Skill } from '@/models/taxonomy/skills';

export enum JobType {
  Current = 'current',
  Desired = 'desired',
}

export interface Occupation {
  id: number;
  name_en: string;
  name_pt: string;
  skill_designations: Skill[];
}

export interface JobTitle {
  id: number;
  name: string;
  occupation?: Occupation;
  occupation_id?: number;
}

export interface UserJob {
  id: string;
  job_title: JobTitle;
  job_type: JobType;
}

export interface UserJobTitles {
  current?: JobTitle;
  desired?: JobTitle;
}
